import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { CSSTransition } from 'react-transition-group'
import './index.css'

interface Props {
  displayHeight?: number | undefined
  icon?: string
  iconSize?: number
  color?: string
  bgSize?: number
  borderRadius?: string
  position?: string
  xOffset?: number
  yOffset?: number
  zIndex?: number
}

export const Scroll: React.FC<Props> = ({
  displayHeight,
  icon,
  color,
  iconSize,
  bgSize,
  borderRadius,
  position,
  xOffset,
  yOffset,
  zIndex,
}) => {
  const Wrap = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${bgSize ? `${bgSize}px` : '40px'};
    height: ${bgSize ? `${bgSize}px` : '40px'};
    border-radius: ${borderRadius ? borderRadius : '5px'};
    position: fixed;
    bottom: 25px;
    left: ${position === 'bottom-left' ? '25px' : null};
    right: ${position === 'bottom-right' ? '25px' : '25px'};
    transform: ${`translate(${xOffset ? xOffset : 0}px, ${
      yOffset ? yOffset : 0
    }px)`};
    z-index: ${zIndex ? zIndex : 0};
    color: white;
    background-color: ${color ? color : 'black'};
    border: 1px solid rgba(0, 0, 0, 0);
    transition: all 0.5s;
    &:hover {
      background-color: white;
      color: ${color ? color : 'black'};
      border: 1px solid ${color ? color : 'black'};
    }
  `

  const Arrow = styled.i`
    font-size: ${iconSize ? `${iconSize}px` : '20px'};
  `

  const [showBtn, setShowBtn] = useState<boolean>(false)

  const handleScroll = () => {
    let displayPosition: number

    if (displayHeight) {
      displayPosition = displayHeight
    } else {
      displayPosition = 300
    }

    const position = window.pageYOffset

    if (position > displayPosition) {
      setShowBtn(true)
    } else {
      setShowBtn(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }

  return (
    <CSSTransition
      in={showBtn}
      timeout={500}
      classNames="fade-in"
      unmountOnExit
    >
      <Wrap onClick={scrollTop} className="scroll-to-top-btn-container">
        <Arrow className={icon ? icon : 'fas fa-arrow-up'}></Arrow>
      </Wrap>
    </CSSTransition>
  )
}
